import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { constants, phoneRegExp } from "constants/constants";
import {
  IUseNpsParentForm,
  IUseNpsParentFormProps,
  IUseNpsParentFormValues
} from "./nps-parent-form.types";
import { ToggleSkipConfirmationTypes } from "../nps-modal/nps-modal.types";
import { useEffect } from "react";

const FormSchema = yup.object().shape({
  phone_number: yup
    .string()
    .required("Nomor Telepon diperlukan")
    .matches(phoneRegExp, "Masukin nomor HP yang aktif, ya.")
    .min(8, "Masukin minimal 8 angka, ya.")
    .max(13, "Nomor terlalu panjang")
});

export const useNpsParentForm = ({
  submitParentNumberForm,
  toggleSkipConfirmation,
  checkParentNumberIsAlreadySubmitted
}: IUseNpsParentFormProps): IUseNpsParentForm<IUseNpsParentFormValues> => {
  const {
    control,
    getValues,
    handleSubmit,
    formState: { isValid }
  } = useForm<IUseNpsParentFormValues>({
    mode: "onChange",
    defaultValues: {
      phone_number: ""
    },
    delayError: constants.DELAY_ERROR,
    resolver: yupResolver(FormSchema)
  });
  useEffect(() => {
    checkParentNumberIsAlreadySubmitted();
  }, []);

  const handleParentFormSubmission = () => {
    const { phone_number } = getValues();
    submitParentNumberForm(phone_number);
  };

  const handleSeeYouLater = (): void => {
    const { phone_number } = getValues();
    toggleSkipConfirmation(
      ToggleSkipConfirmationTypes.PARENT_PHONE_NUMBER_SCREEN,
      phone_number || undefined
    );
  };

  return {
    handleSubmit,
    control,
    isValid,
    handleParentFormSubmission,
    handleSeeYouLater
  };
};
